import { createStore } from 'vuex'
import axios from 'axios'
import { baseURl } from '../extraData'

export default createStore({
  state: {
    loggedUser: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    pickedCliente: localStorage.getItem('pickedCliente') ? JSON.parse(localStorage.getItem('pickedCliente')) : {nome: 'cliente 001'},
    pickedSubCliente: localStorage.getItem('pickedSubCliente') ? JSON.parse(localStorage.getItem('pickedSubCliente')) : {nome: 'sub cliente 001'},
    pickedLocalInstalacao: localStorage.getItem('pickedLocalInstalacao') ? JSON.parse(localStorage.getItem('pickedLocalInstalacao')) : null,
    localChanged: false,


    Emitter: false,
    servicos: {
      formStatus: false,
      editing: false,
      acttion: '',
      editData: {},
    },

    utilizador: {
      data: [],
    },

    clientes: {
      data: [],
      showRightForm: true,
      formStatus: false,
      formFiltroStatus: false,
      selectedSubCliente: {},
      

      formSubClienteStatus: false,
      tableSubClienteStatus: false,
      formlocalInstalacaoStatus: false,
      tablelocalInstalacaoStatus: false,

      formContactoStatus: false,

      clienteFormContactoStatus: false,
      
      editing: false,
      acttion: '',
      editData: {},
      formPedidoStatus: false,
      mapa: false,
      subCliente_id:0,
      cliente_id:0,
    },

  },
  getters: {

    getLocalChanged: state => state.localChanged,

    servicos: state => state.servicos,
    clientesX: state => state.clientes.data,
    utilizadorX: state => state.utilizador.data,

    getPickedCliente: state => state.pickedCliente,

    getPickedSubCliente: state => state.pickedSubCliente,

    getPickedLocalInstalacao: state => state.pickedLocalInstalacao,

  },
  mutations: {

    setLocalChanged(state, data) {
      state.localChanged = data;
    },
    
    setServicos(state, servicos) {
      state.servicos = servicos;
    },

 
    setPickedSubCliente(state, data) {

      try{
        localStorage.setItem('pickedSubCliente', JSON.stringify(data));
      }catch(e){
        console.log(e);
      }

      state.pickedSubCliente = data;
    },

    setPickedLocalInstalacao(state, data) {
     /*  console.log(" ---------- SubCliente picked ----------");
      console.log(" ---------- SubCliente picked ----------");
      console.log(" ---------- SubCliente picked ----------");
      console.log(" ---------- SubCliente picked ----------");   */
        try{
          localStorage.setItem('pickedLocalInstalacao', JSON.stringify(data));
        }catch(e){
          console.log('erro ao guardar local:',e);
        }
  
        state.pickedLocalInstalacao = data;
    },


    setClientes(state, data) {
      state.clientes.data = data;
    },

    setUtilizador(state, data) {
      state.utilizador.data = data;
    },

    setLoggedCliente(state, data) {
      state.pickedCliente = data;
    }

  },
  actions: {
    async fetchLoggedCliente({ commit, state }) {
      // ************************ Guardar o id do Cliente logado ************************
      try {
        const USER = JSON.parse(localStorage.getItem('user'));
        const userId = state.loggedUser?.id || 0;
        const baseUrl = process.env.VUE_APP_URL_BASE;
        console.log("loggedUser in state:",USER);
        // alert("userId: "+userId+" cliente_id: "+state.loggedUser?.cliente_id ?? 0);
        const response = await axios.get(`${baseUrl}/api/v1/cliente/?utilizador_id=${userId}`);
        const logged_cliente = response.data.data || {};
        
        console.log("loggedCliente:", logged_cliente);
        localStorage.setItem('pickedCliente', JSON.stringify(logged_cliente));
        commit('setLoggedCliente', logged_cliente);
      } catch (error) {
        console.error("Erro ao buscar cliente logado", error);
      }
      // *********************************************************************************
  },
    async fetchClientes({ commit }) {
      try {
        const { data } = await axios.get(`${baseURl}/api/v1/cliente/`);
        if(data.data.length >0){
          commit('setClientes', data.data);

        }
      } catch (error) {
        console.log(error);
      }
    },


    async fetchUtilizador({ commit }) {
      try {
        const { data } = await axios.get(`${baseURl}/api/v1/utilizador/`);
        if(data.data.length >0){
          commit('setUtilizador', data.data);

        }
      } catch (error) {
        console.log(error);
      }
    }

    
  }
})



